import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({
  palette,
  spaceXLarge,
  spaceMin,
  breakpoints,
  fontWeights,
  fontFamilies,
}: Theme) => ({
  root: {
    padding: `${spaceXLarge} 0`,
    background: palette.primary.dark,
  },
  contentStyles: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2.5rem',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    [breakpoints.up('md')]: {
      flexDirection: 'row',
    },
    '& > div': {
      flexBasis: '100%',
      [breakpoints.up('md')]: {
        flexBasis: '50%',
      },
    },
  },
  subtitle: {
    margin: '0 0 1.5rem',
    color: palette.primary.light,
    fontSize: '1.75rem',
    fontFamily: fontFamilies.primary,
    fontWeight: fontWeights.regular,
    lineHeight: 1.2,
    letterSpacing: -0.56,
  },
  list: {
    flexDirection: 'column',
    gap: spaceMin,
    margin: '0 0 2.5rem',
  },
  image: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    margin: 0,
  },
  content: {
    margin: 0,
    color: palette.primary.light,
    lineHeight: 1.5,
    fontFamily: fontFamilies.light,
    fontWeight: fontWeights.light,
    '& + p': {
      marginTop: '1.5rem',
    },
  },
  strong: {
    fontFamily: fontFamilies.bold,
    fontWeight: fontWeights.bold,
  },
  generalList: {
    listStyle: 'none',
    display: 'flex',
    padding: 0,
  },
  dataList: {
    marginTop: '1.5rem',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '1.5rem',
    margin: 0,
    [breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  dataListItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: spaceMin,
    lineHeight: 1,
    letterSpacing: -0.32,
  },
  emphasis: {
    color: palette.primary.main,
    fontSize: '4rem',
    lineHeight: 1,
  },
  bottom: {
    color: palette.grey['100'],
  },
}));
